import { tr, appLocale } from './index';
import { parseMultilang } from '@/utils/multilang';

// The built-in system roles (roles.tenant_id is null) are stored as identifiers.
// One literal tr() per role so check_coverage.py sees every key.
const BUILTIN_ROLES: Record<string, () => string> = {
  site_admin: () => tr('role.builtin.site_admin', 'Site Administrator'),
  tenant_admin: () => tr('role.builtin.tenant_admin', 'Tenant Administrator'),
  business_admin: () => tr('role.builtin.business_admin', 'Business Administrator'),
  manager: () => tr('role.builtin.manager', 'Manager'),
  course_creator: () => tr('role.builtin.course_creator', 'Course Creator'),
  editing_trainer: () => tr('role.builtin.editing_trainer', 'Editing Trainer'),
  trainer: () => tr('role.builtin.trainer', 'Trainer'),
  marker: () => tr('role.builtin.marker', 'Marker'),
  sme: () => tr('role.builtin.sme', 'Subject Matter Expert'),
  learner: () => tr('role.builtin.learner', 'Learner'),
  user: () => tr('role.builtin.user', 'User'),
  guest: () => tr('role.builtin.guest', 'Guest'),
  service_account: () => tr('role.builtin.service_account', 'Service Account'),
};

/**
 * Display name of a platform role: a built-in role ("editing_trainer") in the
 * interface language, a tenant's own role as its admin named it (multilang tags
 * resolved, like ml()). Role names are unique across all tenants, so a custom
 * role can never take a built-in name.
 */
export function roleLabel(name: string | null | undefined): string {
  if (!name) return '';
  const builtin = BUILTIN_ROLES[name];
  if (builtin) return builtin();
  // The UI language is fixed per page load; appLocale() is 'ar-u-nu-latn' for Arabic.
  return parseMultilang(name, appLocale().split('-u-')[0]);
}

/** Several roles as one line ("Trainer, Marker"). */
export function roleLabels(names: (string | null | undefined)[]): string {
  return names.map(roleLabel).filter(Boolean).join(', ');
}
